module.exports = __webpack_public_path__ + "static/media/sequence.93326efc.svg";